import { SnapPointIds } from '../types';

/**
 * Initial state of the side drawer.
 */
export const initialDrawerState = {
    download: false,
    emissionsDetails: false,
    ogiData: false,
    targetData: false,
    legend: false,
    settings: false,
    noData: false,
    bottomDrawerSnapPoint: SnapPointIds.preview
};

/**
 * closed state of the side drawer.
 */
const closedDrawerState = {
    // these use DrawerWithCards
    emissionsDetails: false,
    ogiData: false,
    targetData: false,
    // end of drawers using DrawerWithCards
    download: false,
    legend: false,
    settings: false,
    noData: false,
    bottomDrawerSnapPoint: SnapPointIds.preview
};

/**
 * Manages side drawer state.
 */
export function drawerStateReducer(
    _drawers: typeof initialDrawerState,
    action:
        | { type: 'open'; id: keyof typeof initialDrawerState }
        | { type: 'close' }
        | { type: 'setBottomDrawerSnapPoint'; snapPoint: SnapPointIds }
) {
    switch (action.type) {
        case 'open':
            return {
                ...closedDrawerState,
                [action.id]: true,
                bottomDrawerSnapPoint: _drawers.bottomDrawerSnapPoint
            };
        case 'close':
            return closedDrawerState;
        case 'setBottomDrawerSnapPoint':
            return {
                ..._drawers,
                bottomDrawerSnapPoint: action.snapPoint
            };
        default:
            throw Error('unknown action type', action);
    }
}
